export default state => ({
  _data: state,
  _status: { _on_ready: false, _on_loading: false, _on_error: false },
})
